import AppRouter from './Routes';

const App: React.FC = () => {
  return <AppRouter />;
};

export default App;